var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoChangePassword = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock_3_",
    "data-name": "lock (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28659",
    "data-name": "Group 28659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47473",
    "data-name": "Path 47473",
    d: "M75.667,6h-1V4.667a4.667,4.667,0,0,0-9.333,0V6h-1A.333.333,0,0,0,64,6.333v8.333A1.335,1.335,0,0,0,65.333,16h9.333A1.335,1.335,0,0,0,76,14.667V6.333A.333.333,0,0,0,75.667,6ZM71,12.963a.333.333,0,0,1-.331.37H69.333a.333.333,0,0,1-.331-.37l.21-1.891A1.319,1.319,0,0,1,68.667,10a1.333,1.333,0,0,1,2.667,0,1.319,1.319,0,0,1-.546,1.072ZM72.667,6H67.333V4.667a2.667,2.667,0,0,1,5.333,0Z",
    transform: "translate(-64)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoChangePassword);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_change_password.3decd526bb65f3c2f957a30e30e3272a.svg";